import * as __NgCli_locale_1 from "@angular/common/locales/en-GB";
import * as __NgCli_locale_2 from "@angular/common";
__NgCli_locale_2.registerLocaleData(__NgCli_locale_1.default);
import { enableProdMode } from '@angular/core';
import { environment } from '@app/env';
import { getTranslationProviders } from './i18n-providers';
import * as __NgCli_bootstrap_1 from "./app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
if (!environment.production) {
    // when bootstraping a local build, then add translation providers
    getTranslationProviders().then(function (providers) {
        var bootstrapOptions = { providers: providers };
        bootstrapNow(bootstrapOptions);
    });
}
else {
    // when bootstraping a test/prod build translations files are added as build parameters for --aot
    bootstrapNow();
}
// required for IE support (DIET-348)
if (!Array.prototype.includes) {
    Array.prototype.includes = function (search) {
        return this.indexOf(search) !== -1;
    };
}
/*
    In separate function to bypass angularCLI bootstraping bug https://github.com/angular/angular-cli/issues/3540
 */
function bootstrapNow(options) {
    __NgCli_bootstrap_2.platformBrowser()
        .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory, options || {})
        .then(function (ref) { });
}
